import React, {useContext} from 'react';
import EditIcon from '../../../../../assets/svgComponents/EditIcon';
import './anMeetingDescriptionComponent.css';
import {AppContext} from '../../../../../AppModule/Context';

const AnMeetingDescriptionComponent = ({
  isEditIconClicked = false,
  showEditIcon = false,
  meetingTitle = '',
  meetingNotes = '',
  onEditIconClicked = () => {},
  setNotes = () => {},
  setTitle = () => {},
}) => {
  const context = useContext(AppContext);

  return (
    <div
      className={`et-an-mdc-description-wrap ${
        isEditIconClicked ? 'et-an-mdc-description-edit-wrap' : ''
      }`}>
      <div className="et-an-mdc-meeting-title-icon-wrap">
        <input
          className={`et-an-mdc-meeting-title-txt ${
            isEditIconClicked ? 'et-an-mdc-item-selected' : ''
          }`}
          spellCheck={true}
          readOnly={!isEditIconClicked}
          placeholder={context.languageSet.VIDEO_CALL_CAT.MEETING_TITLE}
          value={meetingTitle}
          onChange={(e) => {
            setTitle(e.target.value);
          }}
        />
        {showEditIcon && !isEditIconClicked && (
          <div className="et-an-mdc-edit-icon" onClick={onEditIconClicked}>
            <EditIcon />
          </div>
        )}
      </div>
      {(meetingNotes?.length > 0 || isEditIconClicked) && (
        <textarea
        spellCheck={true}
          className={`et-an-mdc-meeting-notes-txt ${
            isEditIconClicked ? 'et-an-mdc-item-selected' : ''
          }`}
          readOnly={!isEditIconClicked}
          placeholder="Meeting notes ..."
          value={meetingNotes || ''}
          onChange={(e) => {
            setNotes(e.target.value);
          }}></textarea>
      )}
    </div>
  );
};

export default AnMeetingDescriptionComponent;
